import React, { Component } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import Home from '../../pages/Home'
import Cosmetics from '../../pages/Cosmetics'
import Service from '../../pages/Service'
import Prices from '../../pages/Prices'
import News from '../../pages/News'
import NewsItem from '../../pages/NewsItem'

class RouterView extends Component {
  state = {
    isMainModalOpen: true,
  }

  closeMainModal = () => this.setState({ isMainModalOpen: false })

  render() {
    return (
      <Router>
        <div>
          <Route
            exact
            path="/"
            component={props => (
              <Home
                {...this.props}
                {...props}
                isMainModalOpen={this.state.isMainModalOpen}
                closeMainModal={this.closeMainModal}
              />
            )}
          />
          <Route exact path="/kutyakozmetika" component={Cosmetics} />
          <Route path="/szolgaltatasok/:id" component={Service} />
          <Route path="/arak" component={Prices} />
          <Route exact path="/hirek" component={News} />
          <Route path="/hirek/:id" component={NewsItem} />
        </div>
      </Router>
    )
  }
}

export default RouterView



// WEBPACK FOOTER //
// ./src/components/Router/RouterView.js